module.exports = __webpack_public_path__ + "img/sp1rit_scaled.c035a89a.svg";